import {
  GET_ALL_CONTACT_TYPES,
  REMOVE_FILTERS_VALUES,
  GET_ALL_CONTACT_FILTERS,
  ADD_CONTACT_FILTER_TYPE,
  CHANGE_SWITCH,
  CHANGE_FILTERS_VALUES,
  SET_OPTIONS,
  SET_FILTERS_VALUES_ON_LOAD,
  CHANGE_SWITCH_DB,
  REMOVE_FILTER,
  SET_USERS_OPTIONS,
  CLEAR_FILTERS,
} from './types'

const initialState = { typeId: null, filtersValues: {}, filtersDB: [] }

export default function (state = initialState, action) {
  switch (action.type) {
    case CLEAR_FILTERS:
      return {
        ...state,
        filtersDB: [],
        filtersValues: {},
      }
    case GET_ALL_CONTACT_TYPES:
      return {
        ...state,
        types: action.payload,
      }
    case GET_ALL_CONTACT_FILTERS:
      return {
        ...state,
        filters: action.payload.data,
        typeId: action.payload.typeId,
      }
    case ADD_CONTACT_FILTER_TYPE:
      return {
        ...state,
        types: [...state.types, action.payload],
        typeId: action.payload.id,
        filters: {},
      }
    case CHANGE_SWITCH_DB:
      return {
        ...state,
        filtersDB: [...state.filtersDB, { ...action.payload }],
      }
    case CHANGE_SWITCH:
      // todo delete not working with custom names.... [divisions.account_date eg]
      delete state.filtersValues[action.payload.name]
      return {
        ...state,
        filters: { ...state.filters, [action.payload.name]: action.payload.value },
      }
    case CHANGE_FILTERS_VALUES:
      return {
        ...state,
        filtersValues: { ...state.filtersValues, [action.payload.name]: action.payload.value },
      }
    case REMOVE_FILTERS_VALUES:
      return {
        ...state,
        filtersValues: {},
      }
    case SET_FILTERS_VALUES_ON_LOAD:
      return {
        ...state,
        filtersValues: action.payload,
      }
    case SET_OPTIONS:
      return {
        ...state,
        nationalities: action.payload,
      }
    case SET_USERS_OPTIONS:
      return {
        ...state,
        nationalities: { ...state?.nationalities, Users: action.payload },
      }
    case REMOVE_FILTER:
      // eslint-disable-next-line no-unused-vars
      const { [action.payload]: filterToRemove, ...otherFilters } = state.filtersValues
      return {
        ...state,
        filtersValues: otherFilters,
      }
    default:
      return state
  }
}
